import PhoneNumberInputUncontrolled
  from "./PhoneNumberInputUncontrolled";
import withFieldInfo from "~/field/components/FieldInfo/withFieldInfo";

export default withFieldInfo(PhoneNumberInputUncontrolled);
